"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addStyleSheet = void 0;
function addStyleSheet(stylesheet) {
    const style = document.createElement('style');
    style.textContent = stylesheet;
    document.head.append(style);
    return style;
}
exports.addStyleSheet = addStyleSheet;
//# sourceMappingURL=add-style-sheet.js.map